module.exports = {"511824001":"棉城街道","511824100":"新棉镇","511824200":"安顺彝族乡","511824201":"先锋藏族乡","511824202":"蟹螺藏族乡","511824203":"永和乡","511824204":"回隆彝族乡","511824205":"擦罗彝族乡","511824206":"栗子坪彝族乡","511824207":"美罗乡","511824208":"迎政乡","511824209":"宰羊乡","511824210":"丰乐乡","511824211":"新民藏族彝族乡","511824212":"挖角彝族藏族乡","511824213":"田湾彝族乡","511824214":"草科藏族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511824.json
// module id = 2199
// module chunks = 0